import { NameLumberJack } from './NameLumberJack'
import { AccountId } from '@/Domain/Account/AccountId'
import { State } from './State'
import { Ofert } from './Ofert'

export class Lumberjack {
  private _nameLumberJack: NameLumberJack
  private _nif: AccountId
  private _ofert: Ofert | null
  private _state: State

  constructor (
    nameLumberJack: NameLumberJack,
    nif: AccountId,
    ofert: Ofert | null,
    state: State
  ) {
    this._nameLumberJack = nameLumberJack
    this._nif = nif
    this._ofert = ofert
    this._state = state
  }

  nameLumberJack (): string {
    return this._nameLumberJack.nameLumberJack()
  }

  nif (): string {
    return this._nif.accountId()
  }

  ofert (): string {
    return this._ofert === null ? '' : this._ofert.toString()
  }

  state (): string {
    return this._state.state()
  }
}
